import { Component, ElementRef, OnDestroy, Renderer2 } from '@angular/core';
import { Title } from '@angular/platform-browser';
// import { Router } from '@angular/router';
import { TagService } from './tag.service';
// import { WindowReferenceService } from './windowReference.service';
// import { UpdateService } from './update.service';
import { TranslateService } from '@ngx-translate/core';
import { NavigationEnd, Router } from '@angular/router';
import { WindowReferenceService } from './windowReference.service';
import { Subscription } from 'rxjs';
// import defaultLanguage from "./../assets/i18n/en.json";
// declare let $: any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})


export class AppComponent implements OnDestroy {
  subs: Subscription[] = [];
  private window;
  previousUrl: string = '';
  currentUrl: string = '';

  // private modalIds = ['vx-modal-privacy', 'vx-modal-terms', 'productModal'];

  private awCodeMap = {
    'successdemo': 'AW-877994557/uGASCKORjt8CEL3E1KID',
    'successquote': 'AW-877994557/mdYSCPGajt8CEL3E1KID',
    'successsales': 'AW-877994557/1mStCKXasN8CEL3E1KID',
    'success': 'AW-877994557/nRnkCJHat98CEL3E1KID'
  };


  constructor(
    private titleService: Title,
    public _tagService: TagService,
    public translate: TranslateService,
    public _router: Router,
    private _windowRef: WindowReferenceService,
    private el: ElementRef,
    private renderer: Renderer2
    ) {
    // console.log('APP COMPONENT CONSTRUCTOR');
    this.window = this._windowRef.nativeWindow;
    this.titleService.setTitle('VeEX Inc. | The Verification EXperts');
    translate.addLangs(['en', 'es', 'fr', 'zh']);
    translate.setDefaultLang('en');
    let browserLang = translate.getBrowserLang();
    const windowHref = window.location.href;
    const languageMap = {
      'veexinc.cn': 'zh',
      'carso': 'es'
    };
    const detectedLang = Object.keys(languageMap).find(key => windowHref.includes(key));
    browserLang = detectedLang ? languageMap[detectedLang] : 'en';
    translate.use(browserLang.match(/en|es|fr|zh/) ? browserLang : 'en');
    this.subs.push(this._router.events.subscribe((e) => {
      // console.log('APP COMPONENT ROUTER');
      if (e instanceof NavigationEnd) {
        // $('.modal').modal('hide');
        const modalElement = this.el.nativeElement.querySelector('.modal.fade.show');
        if (modalElement) {
          console.log(modalElement.getAttribute('id'));
          const modalId = modalElement.getAttribute('id');
          
          if (modalId) {
            this.createAndClickCloseButton(modalId);
          }
        }
        console.log('APP COMPONENT NAVIGATION END');
        this.previousUrl = this.currentUrl;
        this.currentUrl = e.url;
        this._tagService.previousUrl = this.previousUrl;
        // console.log('CURRENT:', this.currentUrl);
        if(this._router.url === '/'){
          this._tagService.resetTags();
          this._tagService.setCanonicalURL();
        } else {
          this._tagService.setCanonicalURL();
        }
        // console.log('PREVIOUS:', this._tagService.previousUrl);
        const gtmTag = {
          event: 'page',
          pageName: windowHref
        };
        if (gtmTag && this.window.dataLayer) {
          this.window.dataLayer.push(gtmTag);
        }
        let awtemp = this.getAWCode(windowHref);
        if (awtemp.length > 1) {
          const newgtmTag = {
            event: 'conversion',
            send_to: awtemp
          };
          if (newgtmTag && this.window.dataLayer) {
            this.window.dataLayer.push(newgtmTag);
            awtemp = '';
          }
        }
        if (!windowHref.includes('/support/rmarequest')) {
          // tslint:disable-next-line: no-string-literal
          const _hsq = window['_hsq'] = window['_hsq'] || [];
          _hsq.push(['setPath', windowHref]);
          _hsq.push(['trackPageView']);
        }
        const style = document.getElementById('modal-backdrop-opacity-style');
        if (style) {
          style.remove();
        }
      }
    }));
  }
  private createAndClickCloseButton(modalId: string) {
    const closeButton = this.renderer.createElement('button');
    this.renderer.setAttribute(closeButton, 'type', 'button');
    this.renderer.addClass(closeButton, 'btn-close');
    this.renderer.setAttribute(closeButton, 'data-bs-dismiss', 'modal');
    this.renderer.setAttribute(closeButton, 'data-bs-target', `#${modalId}`);
    this.renderer.setAttribute(closeButton, 'aria-label', 'Close');

    // Append the button to the body (or another container)
    this.renderer.appendChild(document.body, closeButton);

    // Trigger a click on the button
    closeButton.click();
    
    // Remove the button from the DOM
    this.renderer.removeChild(document.body, closeButton);
  }
  private getAWCode(url: string): string {
    for (const key in this.awCodeMap) {
      if (url.includes(key)) {
        return this.awCodeMap[key];
      }
    }
    return '';
  }
  ngOnDestroy(): void {
    this.subs.forEach((sub) => {
      sub.unsubscribe();
    });
  }
  
}
